function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "32",
  height: "32",
  viewBox: "0 0 23 23"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M18.8 6.6c0 1.3-1.1 2.4-2.4 2.4C15.1 9 14 7.9 14 6.6c0-1.3 1.1-2.4 2.4-2.4 1.3 0 2.4 1.1 2.4 2.4zm-1.5 0c0 .5-.4.9-.9.9s-.9-.4-.9-.9.4-.9.9-.9c.4 0 .9.4.9.9zM7.8 11c-.3-.8-.5-1.8-.5-2.7 0-4.1 3.4-7.5 7.5-7.5s7.5 3.4 7.5 7.5-3.4 7.5-7.5 7.5c-1 0-1.9-.2-2.8-.5l-1.6 1.6c-.1.1-.2.1-.3.1H8.5s-.1 0-.1.1v1.4c0 .2-.2.4-.4.4h-.3c-.2 0-.4.2-.4.4v.3c0 .2-.2.4-.4.4H5.4s-.1 0-.1.1v1.8c0 .1 0 .2-.1.3l-.8.8H.2v-4.2L7.8 11zm13-2.8c0 3.3-2.7 6-6 6-.5 0-1.1-.1-1.6-.2s-1-.4-1.5-.6l-2 2H8.5c-.9 0-1.6.7-1.6 1.6v.5c-.4.2-.7.5-.9.9h-.6c-.9 0-1.6.7-1.6 1.6v1.3H1.7v-2.1l7.9-7.9c-.3-.5-.5-1-.6-1.5-.1-.5-.2-1-.2-1.5 0-3.3 2.7-6 6-6s6 2.6 6 5.9z",
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "currentColor"
})));